"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function CarouselArrow(_a) {
    var onClick = _a.onClick, direction = _a.direction, BaseArrow = _a.arrow, style = _a.style, className = _a.className;
    if (BaseArrow)
        return react_1.default.createElement(BaseArrow, { direction: direction, onClick: onClick });
    return (react_1.default.createElement(styles_1.CarouselArrowContainer, { onClick: onClick, direction: direction },
        react_1.default.createElement(styles_1.CarouselArrowIcon, { className: className, style: style, direction: direction })));
}
exports.default = CarouselArrow;
//# sourceMappingURL=index.js.map